
const flatten = (source, list) => {
    if (list === undefined) {
        list = []
    }
    for (const objs of (source || [])) {
        let {childrens, ...item} = objs
        list.push(item)
        flatten(childrens, list)
    }
    return list
  }
  export default flatten;